import React from "react";
import {connect} from "react-redux";
import {ModalTypes} from "../../../tools/StaticTypes";
import {
    addModalData,
    deleteModalData,
    setLoaderModalData
} from "../../../store/globalState/actionCreators/globalState_AppActionCreator";
import {__, HelpFunctions, validateAttributeJSONByTable, validateAttributeJSONByTree} from "../../../tools/HelpFunctions";
import AceEditor from "react-ace";
import {apiRequestNew} from "../../../tools/API/apiRequest";
import {apiUrl} from "../../../tools/API/apiUrl";
import {store} from "../../../index";
import {SEARCH_PREVIEW_ACTIONS} from "../../../store/search/searchActionsList";
import {DOCUMENT_PREVIEW_ACTIONS} from "../../../store/documents/documentActionsList";
import {PACKAGES_TREE_ACTIONS} from "../../../store/packages/packageActionsList";


// modal.data.content => обязательно
class ModalEditContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: this.props.modal.data?.text || '',
        };

        this.modalName = ModalTypes.app.show;

        this.hide = this.hide.bind(this);
        this.hideOutSide = this.hideOutSide.bind(this);
        this.save = this.save.bind(this);
    }

    // скрывать по кнопке
    hide() {
        this.props.deleteModalData({modalId: this.props.modal.id})
    }

    hideOutSide() { // скрывать при клике вне окна
        if (!this.state.contentOnHover) this.hide();
    }

    async save() {
        store.dispatch(setLoaderModalData({
            data : {content : "Загрузка...", disableButton : true, fullBackground : false, gif : "documents", key : "EditContentSave" }
        }));
        console.log("Обновление содержания",this.props.modal.data);

        const response = await new apiRequestNew({
            action : apiUrl.DOCUMENTS.UPDATE_DOC_TEXT,
            headers : null,
            params : {
                id : this.props.modal.data.docId,
                text : this.state.text
            }
        }).execute();

        if(!response.ok) {
            console.log(response, await response.json());
            console.log("Обновление содержания");
        }

        // const updateResponse = await new apiRequestNew({
        //     action : apiUrl.DOCUMENTS.UPDATE_DOC_TEXT,
        //     headers : null,
        //     params : {
        //         id : this.props.modal.data.docId,
        //         text : this.state.text
        //     }
        // }).execute();
        if(this.props.modal.data.path == "documents"){
            store.dispatch({
                type: DOCUMENT_PREVIEW_ACTIONS.UPDATE_DATA_FOR_CONTENT_SECTION,
                payload: { contentSection: this.state.text }
            })
        } else if(this.props.modal.data.path == "cards"){
            store.dispatch({
                type: DOCUMENT_PREVIEW_ACTIONS.UPDATE_DATA_FOR_CONTENT_SECTION,
                payload: { contentSection: this.state.text , cardId: this.props.modal.data.cardId, IsCard: true}
            })
        }else if(this.props.modal.data.path == "packages"){
            store.dispatch({
                type: PACKAGES_TREE_ACTIONS.UPDATE_CONTENT,
                payload: { contentSection: this.state.text }
            })
            if (this.props.modal.data.callback) this.props.modal.data.callback();
        }else if(this.props.modal.data.path == "search"){
            store.dispatch({
                type: SEARCH_PREVIEW_ACTIONS.UPDATE_CONTENT,
                payload: { contentSection: this.state.text }
            })
            if (this.props.modal.data.callback) this.props.modal.data.callback();
        }

        this.props.addModalData({
            name: ModalTypes.app.info,
            data: {type: "success", content: `Содержимое документа успешно изменено`}
        });
        this.props.deleteModalData({modalId: this.props.modal.id})
        this.props.setLoaderModalData({keyDeleted: "EditContentSave"});

    }

    render() {
        let modalStyle = {
            display: "block",
            backgroundColor: "#061c3e66",
        };


        return (
            <>
                <div className="modal fade show modal-custom" style={modalStyle} onClick={this.hideOutSide}>
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-l"
                         style={{minWidth: '500px', width: 'fit-content'}}
                    >
                        <div className="modal-content  modal-content-json"
                             onMouseEnter={() => this.setState({contentOnHover: true})}
                             onMouseLeave={() => this.setState({contentOnHover: false})}
                             onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-header p-4 border-bottom-0">
                                <h5 className="modal-title text-success font-weight-bolder ">
                                    Редактировать содержимое файла
                                </h5>
                            </div>
                            <div className={`modal-body beautiful-scroll-10 modal-body-json`}>
                                <textarea 
                                    className={`w-100 h-100`} 
                                    value={this.state.text || ''}
                                    onChange={(e) => this.setState({text: e.target.value})}
                                />
                            </div>
                            <div className="modal-footer align-content-center text-center justify-content-center">
                                <button type="button"
                                        className="btn btn-lg btn-light-success"
                                        onClick={this.hide}
                                >
                                    Закрыть
                                </button>
                                <button type="button"
                                        className="btn btn-lg btn-primary"
                                        onClick={this.save}
                                >
                                    Принять изменения
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


const mapStateToProps = state => {
    return {
        router: state.router,
    }
}

const mapDispatchToProps = {
    addModalData,
    deleteModalData,
    setLoaderModalData,
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditContent);
